import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

function ProductVoceda() {
  usePageMeta(
    'Voceda',
    'Voceda is a web app at voceda.com for generating classroom-ready teaching and learning resources.'
  );

  return (
    <>
      <section className="product-hero">
        <div className="container">
          <div className="product-hero-top">
            <span className="badge badge--live">Available</span>
            <span style={{ color: 'var(--text-muted)', fontWeight: 600, fontSize: '0.9rem' }}>
              For teachers · Web app · voceda.com
            </span>
          </div>
          <h1>Voceda</h1>
          <p className="product-hero-lead">
            Voceda is a web-based tool that helps teachers generate learning
            resources for their classes — cutting down the time spent
            building materials from scratch.
          </p>
          <div className="hero-actions">
            <a
              href="https://voceda.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Visit voceda.com
            </a>
            <Link to="/contact" className="btn btn-secondary">
              Ask us a question
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: 'start' }}>
            <div>
              <h2>What it does</h2>
              <p>
                Instead of building worksheets and learning resources from
                a blank page, Voceda gives teachers a faster starting
                point — generating resources that can be used as-is or
                customised for a specific class or topic.
              </p>
            </div>
            <div>
              <h2>Built for</h2>
              <ul className="feature-list">
                <li>
                  <span className="feature-tick">✓</span>
                  <span>Teachers who need learning resources ready quickly</span>
                </li>
                <li>
                  <span className="feature-tick">✓</span>
                  <span>Customising materials to a specific lesson or topic</span>
                </li>
                <li>
                  <span className="feature-tick">✓</span>
                  <span>Cutting down time spent on resource prep each week</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="callout callout--amber">
            <span className="badge badge--soon" style={{ marginBottom: 12 }}>
              Coming soon to Voceda
            </span>
            <h3 style={{ marginBottom: 8 }}>Worksheets from videos & transcripts</h3>
            <p style={{ marginBottom: 0 }}>
              We're building a new tool inside Voceda that turns a video or
              transcript straight into a ready-to-use worksheet — designed
              to save teachers even more time on resource prep.
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2 style={{ marginBottom: 8 }}>Ready to give Voceda a try?</h2>
              <p>Head to voceda.com, or reach out if you have questions first.</p>
            </div>
            <div className="cta-banner-actions">
              <a href="https://voceda.com" target="_blank" rel="noopener noreferrer" className="btn btn-amber">
                Visit voceda.com
              </a>
              <Link to="/contact" className="btn btn-secondary">
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductVoceda;
